
import { useState, useEffect } from 'react';

import { getMasterDataResult } from '../../api';

export const useMasterDataResult = (id) => {
  const [values, updateValues] = useState([]);
  const [loading, updateLoading] = useState(false);


  useEffect(() => {
    (async () => {
      updateLoading(true);
      const response = await getMasterDataResult(id);
      updateLoading(false);

      if (response) {
        updateValues(response);
      }
    })();
  }, [id]);

  return [values, loading];
};
